export default __webpack_public_path__ + "static/media/pure-min.95767f87.png";